import { forwardRef } from 'react';
import { Box as MuiBox } from '@mui/material';
import { unstable_extendSxProp as extendSxProp } from '@mui/system';

// MUI v9 removed top-level system props from Box (createBox no longer calls
// extendSxProp, and only strips theme/sx/as). This project authors layout with
// system shorthands (display, justifyContent, gap, p, m, minHeight, ...) on Box
// across ~120 files. This compat wrapper folds those shorthands back into `sx`,
// preserving the Mantis 4.0 authoring style without touching every call site.
// Wired via a Vite alias on '@mui/material/Box' (see vite.config.mjs).
const Box = forwardRef(function Box(props, ref) {
  return <MuiBox ref={ref} {...extendSxProp(props)} />;
});

export default Box;
